<div id="wrapper">
  <div class="container-fluid">
    <div class="row">
      <div class="col d-flex flex-column align-items-center">
        <h1 style="font-size: 2.5rem;">Causa Básica Y10-Y34</h1>
        <h4 class="mt-1">Óbitos linkados</h4>
      </div>
    </div>
  </div>

  <section class="container-grid">
    <div class="content-header pl-5">
      <div class="d-flex align-items-center justify-content-end">
        <div id="buttons-container" class="d-flex card-title" style="height: 2rem; margin-top: 35px;">
          <button class="btn btn-primary btn-sm mr-1 d-flex align-items-center" @click="viewFilters">
            <i class="fas fa-filter mr-2"></i>
            Filtrar
          </button>
          <button class="btn btn-success btn-sm mr-1" @click="applyFilters">Aplicar filtros</button>
          <button class="btn btn-secondary btn-sm mr-1" @click="clearFilters">Limpar filtros</button>
          <button class="btn btn-info btn-sm" @click="exportCSV">Exportar CSV</button>
        </div>
      </div>
    </div>
    <table-lite
      :rows="table.rows"
      :columns="table.columns"
      :sortable="table.sortable"
      :is-slot-mode="true"
      :pageSize="perPage"
      :page="currentPage"
      :pageOptions="table.pageOptions"
      :total="table.totalRecordCount"
      @do-search="doSearch"
    >
      <template v-slot:actions="props">
        <div v-if="props.value?.numDO !== -1">
          <button
            class="btn btn-sm btn-success"
            style="color: #fff" 
            @click="openModal({ modal: 'modalRegister', data: props.value })"
          >
            <i class="fas fa-search"></i>
          </button>
        </div>
      </template>

      <template v-slot:status="props">
        <div v-if="showFilters && props.value?.status === -1">
          <MultiSelect
            v-model="filters.status"
            :options="statusOptions"
            optionLabel="name"
            class="border bg-white"
            style="width: 67px"
          />
        </div>
        <span
          v-else
          class="fw-bold rounded px-1"
          :class="{
            'bg-danger': ![1, 2].includes(props.value.status),
            'bg-warning': props.value.status === 1,
            'bg-success': props.value.status === 2,
            'text-white': props.value.status === 2,
          }"
        >
          {{ statusEnum[props.value.status ?? 0] }}
        </span>
      </template>

      <template v-slot:concordaReclassificacao="props">
        <div v-if="showFilters && props.value?.concordaReclassificacao === -1">
          <MultiSelect
            v-model="filters.concordaReclassificacao"
            :options="concordanciaOptions"
            optionLabel="name"
            class="border bg-white"
            style="width: 100%"
          />
        </div>
        <span
          v-else
          class="fw-bold rounded px-1"
          :class="{
            'bg-danger': props.value.concordaReclassificacao === false,
            'bg-success': props.value.concordaReclassificacao === true,
          }"
          v-tooltip="props.value.causaBasicaReclassificadaDesc"
        >
          {{ concordaEnum[props.value.concordaReclassificacao ?? ""] }}
        </span>
      </template>

      <template v-slot:numDO="props">
        <template v-if="showFilters && props.value?.numDO === -1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="filters.numDO"
            style="width: 75px"
            @keydown.enter="handleSearch"
          />
        </template>
        <template v-else>
          <div style="width: 75px">
            {{ props.value.numDO }}
          </div>
        </template>
      </template>

      <template v-slot:sexo="props" >
        <template v-if="showFilters && props.value?.sexo === -1">
          <MultiSelect
            v-model="filters.sexo"
            :options="sexoOptions"
            optionLabel="name"
            class="border bg-white"
            style="width: 60px"
          />
        </template>
        <template v-else>
          {{ props.value.sexo }}
        </template>
      </template>

      <template v-slot:idadeObito="props" >
        <template v-if="showFilters && props.value?.idadeObito === -1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="filters.idadeObito"
            style="width: 60px"
            @keydown.enter="handleSearch"
          />
        </template>
        <template v-else>
          {{ props.value.idadeObito }}
        </template>
      </template>

      <template v-slot:ufResidencia="props" >
        <template v-if="showFilters && props.value?.ufResidencia === -1">
          <MultiSelect
            v-model="filters.ufResidencia"
            :options="ufOptions"
            optionLabel="code"
            class="border bg-white"
            style="width: 45px"
          />
        </template>
        <template v-else>
          {{ props.value.ufResidencia }}
        </template>
      </template>

      <template v-slot:codigoMunicipioResidencia="props" >
        <template v-if="showFilters && props.value?.codigoMunicipioResidencia === -1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="filters.codigoMunicipioResidencia"
            @keydown.enter="handleSearch"
          />
        </template>
        <template v-else>
          {{ props.value.codigoMunicipioResidencia }}
        </template>
      </template>

      <template v-slot:dataObito="props" >
        <template v-if="showFilters && props.value?.dataObito === -1">
          <input
            type="text"
            v-model="filters.dataObito"
            v-maska
            data-maska="##/##/####"
            placeholder="DD/MM/AAAA"
            class="form-control form-control-sm"
            style="width: 100px"
            @keydown.enter="handleSearch"
          />
        </template>
        <template v-else>
          <div style="width: 100px">
            {{ props.value.dataObito }}
          </div>
        </template>
      </template>

      <template v-slot:acidenteTrabalho="props" >
        <template v-if="showFilters && props.value?.acidenteTrabalho === -1">
          <MultiSelect
            v-model="filters.acidenteTrabalho"
            :options="acidTrabOptions"
            optionLabel="name"
            class="border bg-white"
            style="width: 100%"
          />
        </template>
        <template v-else>
          {{ props.value.acidenteTrabalhoRevisado || props.value.acidenteTrabalho || '-' }}
        </template>
      </template>

      <template v-slot:codigoCausaBasica="props" >
        <template v-if="showFilters && props.value?.causaBasica === -1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="filters.causaBasica"
            @keydown.enter="handleSearch"
          />
        </template>
        <template v-else>
          <span v-tooltip="props.value.causaBasica">
            {{ props.value.codigoCausaBasica || '-' }}
          </span>
        </template>
      </template>

      <template v-slot:codigoCausaBasicaReclassificada="props" >
        <template v-if="showFilters && props.value?.causaBasicaReclassificada === -1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="filters.causaBasicaReclassificada"
            @keydown.enter="handleSearch"
          />
        </template>
        <template v-else>
          <span v-tooltip="props.value.causaBasicaReclassificada">
            {{ props.value.codigoCausaBasicaReclassificada || '-' }}
          </span>
        </template>
      </template>

      <template v-slot:tipoObito="props" >
        <template v-if="showFilters && props.value?.tipoObito === -1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="filters.tipoObito"
            @keydown.enter="handleSearch"
          />
        </template>
        <template v-else>
          {{ props.value.tipoObitoRevisado || props.value.tipoObito || '-' }}
        </template>
      </template>

      <template v-slot:dataRevisao="props" >
        <template v-if="showFilters && props.value?.dataRevisao === -1">
          <input
            type="text"
            v-model="filters.dataRevisao"
            v-maska
            data-maska="##/##/####"
            placeholder="DD/MM/AAAA"
            class="form-control form-control-sm"
            style="width: 100px"
            @keydown.enter="handleSearch"
          />
        </template>
        <template v-else>
          <div style="width: 100px">
            {{ props.value.dataRevisao }}
          </div>
        </template>
      </template>
    </table-lite>

    <transition name="fade">
      <div v-if="isLoading > 0" class="fullscreen-div">
        <div style="transform: translate(-50%, -50%); font-size: 1.8rem;">
          <div class="spinner-border text-primary" role="status"></div>
        </div>
      </div>
    </transition>
  </section>
</div>

<div class="modal fade show" style="display: block;" v-if="modalRegister.show">
  <div class="modal-dialog modal-lg" style="max-width: 1200px;">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title" v-if="selectedRow">DO {{ selectedRow.numDO }} - {{ selectedRow.sex }}
          - Residência em {{ selectedRow.city }} - {{ selectedRow.state }} - {{ selectedRow.age }} anos - Óbito em {{ selectedRow.deathDate }}
        </h6>
        <button type="button" class="close" aria-label="Fechar" @click="closeModal('modalRegister')">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <b-tabs fill active-nav-item-class="font-weight-bold text-uppercase text-success">
          <b-tab title="Óbito">
            <div style="background-color: #fff; " class="p-3 d-flex mt-2 justify-content-between">
              <div class="p-3 info-container" style="width: 29%;">
                <h2 class="font-weight-bold"><span>IDENTIFICAÇÃO</span></h2>
                <div class="d-flex">
                  <label>Número DO: &nbsp;</label>
                  {{ registro.numDO }}
                </div>
                <div class="d-flex">
                  <label>Data Óbito: &nbsp;</label>
                  {{ registro.dataObito }}
                </div>
 
                <div class="d-flex">
                  <label>UF Ocorrência: &nbsp;</label>
                  {{ registro.codigoEstabelecimentoOcorrencia }}
                </div>
                <div class="d-flex">
                  <label>Município Ocorrência: &nbsp;</label>
                  {{ registro.codigoMunicipioOcorrencia }}
                </div>
 
                <div class="d-flex">
                  <label>UF Residência: &nbsp;</label>
                  {{ registro.ufResidencia }}
                </div>
                <div class="d-flex">
                  <label>Município Residência: &nbsp;</label>
                  {{ registro.codigoMunicipioResidencia }}
                </div>

                <div class="d-flex">
                  <label>Local Ocorrência: &nbsp;</label>
                  {{ registro.localOcorrencia }}
                </div>
              </div>
 
              <div id="2nd-column" style="width: 29%;">
                <div class="p-3 info-container w-100 mb-4" id="2nd-column-container">
                  <h2 class="font-weight-bold"><span>CARACTERIZAÇÃO</span></h2>
                  <div>
                    <div class="d-flex">
                      <label>Sexo: &nbsp;</label>
                      {{ registro.sexo }}
                    </div>
                    <div class="d-flex">
                      <label>Idade: &nbsp;</label>
                      {{ registro.idade }}
                    </div>
                  </div>
                  <div class="d-flex">
                    <div class="d-flex">
                      <label>Raça/Cor: &nbsp;</label>
                      {{ registro.racaCor }}
                    </div>
                  </div>
                </div>
 
                <div class="p-3 info-container w-100">
                  <h2 class="font-weight-bold"><span>CAUSAS EXTERNAS</span></h2>
                  <div class="d-flex">
                    <label>Tipo óbito não natural: &nbsp;</label>
                    {{ registro.tipoObito || "-" }}
                  </div>
                  <div class="d-flex mb-2">
                    <div class="f-flex flex-column">
                      <label>Tipo óbito não natural: &nbsp;<br><span style="margin-left: 4.5rem;">(revisado)</span></label>
                    </div>
                    <select
                      v-model="registro.tipoObitoRevisado"
                      class="w-50"
                      style="height: 1.8rem"
                      @change="openModal({
                        modal: 'modalConfirm',
                        title: `Confirma a alteração do tipo óbito não natural para '${registro.tipoObitoRevisado}'?`,
                        action: () => setDeathTypeReviewed(),
                        actionCancel: () => {
                          registro.tipoObitoRevisado = registro.tipoObitoRevisadoOriginal;
                          closeModal('modalConfirm');
                        },
                      })"
                    >
                      <option value="9 - Ignorado">Ignorado</option>
                      <option value="1 - Acidente">Acidente</option>
                      <option value="2 - Suicídio">Suicídio</option>
                      <option value="3 - Homicídio">Homicídio</option>
                      <option value="4 - Outros">Outros</option>
                    </select>
                  </div>
                  <div class="d-flex">
                    <label>Acidente Trabalho?: &nbsp;</label>
                    {{ registro.acidenteTrabalho || "-" }}
                  </div>
                  <div class="d-flex">
                    <div class="f-flex flex-column">
                      <label>Acidente Trabalho?: &nbsp; <br><span style="margin-left: 4rem;">(revisado)</span></label>
                    </div>
                    <select
                      v-model="registro.acidenteTrabalhoRevisado"
                      class="w-50"
                      style="height: 1.8rem"
                      @change="openModal({
                        modal: 'modalConfirm',
                        title: `Confirma a alteração de Acidente Trabalho para '${registro.acidenteTrabalhoRevisado}'?`,
                        action: () => setWorkAccidentReviewed(),
                        actionCancel: () => {
                          registro.acidenteTrabalhoRevisado = registro.acidenteTrabalhoRevisadoOriginal;
                          closeModal('modalConfirm');
                        },
                      })"
                    >
                      <option value="Ignorado">Ignorado</option>
                      <option value="Sim">Sim</option>
                      <option value="Não">Não</option>
                    </select>
                  </div>
                  <div class="d-flex align-items-start">
                    <label style="min-width: 140px;">Descrição do evento:</label>
                    <p>
                      {{ registro.dsEvento || "-" }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="p-3 info-container" style="width: 40%;">
                <h2 class="font-weight-bold"><span>ATESTADO</span></h2>
                <div class="d-flex">
                  <label>Linha A: &nbsp;</label>
                  {{ registro.linhaA }}
                </div>
                <div class="d-flex">
                  <label>Linha B: &nbsp;</label>
                  {{ registro.linhaB}}
                </div>
                <div class="d-flex">
                  <label>Linha C: &nbsp;</label>
                  {{ registro.linhaC }}
                </div>
                <div class="d-flex">
                  <label>Linha D: &nbsp;</label>
                  {{ registro.linhaD }}
                </div>
                <div class="d-flex">
                  <label>Linha II: &nbsp;</label>
                  {{ registro.linhaII }}
                </div>
                <div class="d-flex">
                  <label>Causa Básica: &nbsp;</label>
                  {{ registro.codigoCausaBasica ? `${registro.codigoCausaBasica} - ${registro.causaBasica}` : '-' }}
                </div>
                  <div class="d-flex">
                  <label>Causa Básica Original: &nbsp;</label>
                  {{ registro.codigoCausaBasicaOriginal ? `${registro.codigoCausaBasicaOriginal} - ${registro.causaBasicaOriginal}` : '-' }}
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab title="Internação" class="mt-3">
            <table-lite
              style="font-size: .7rem"
              :rows="registro.internacoes"
              :columns="table.multiPageTableColumns.internacao"
              :isHidePaging="true"
              :is-slot-mode="true"
              @do-search="(offset, limit, order, sort) => doSearchSubTable(registro.internacoes, order, sort)"
            ></table-lite>
          </b-tab>
          <b-tab title="Violência" class="mt-3">
            <table-lite
              style="font-size: .7rem"
              :rows="registro.violencias"
              :columns="table.multiPageTableColumns.violencias"
              :isHidePaging="true"
              :is-slot-mode="true"
              @do-search="(offset, limit, order, sort) => doSearchSubTable(registro.violencias, order, sort)"
            ></table-lite>
          </b-tab>
          <b-tab title="Acidente transporte" class="mt-3">
            <table-lite
              style="font-size: .7rem"
              :rows="registro.acidentesTransporte"
              :columns="table.multiPageTableColumns.transporte"
              :isHidePaging="true"
              :is-slot-mode="true"
              @do-search="(offset, limit, order, sort) => doSearchSubTable(registro.acidentesTransporte, order, sort)"
            ></table-lite>
          </b-tab>
          <b-tab title="Acidente trabalho" class="mt-3">
            <table-lite
              style="font-size: .7rem"
              :rows="registro.acidentesTrabalho"
              :columns="table.multiPageTableColumns.trabalho"
              :isHidePaging="true"
              :is-slot-mode="true"
              @do-search="(offset, limit, order, sort) => doSearchSubTable(registro.acidentesTrabalho, order, sort)"
            ></table-lite>
          </b-tab>
          <b-tab title="Intoxicação" class="mt-3">
            <table-lite
              style="font-size: .7rem"
              :rows="registro.intoxicacoes"
              :columns="table.multiPageTableColumns.intoxicacoes"
              :isHidePaging="true"
              :is-slot-mode="true"
              @do-search="(offset, limit, order, sort) => doSearchSubTable(registro.intoxicacoes, order, sort)"
            ></table-lite>
          </b-tab>
        </b-tabs>
      </div>
      <div class="modal-footer justify-content-between" id="responsive-footer">
        <div id="text-container" style="width: 80%;">
          <h5 class="font-weight-bold p-0 m-0">Agrupamento ML: {{ registro.agrupamentoML }}</h5>
          <p>{{ registro.agrupamentoMLDesc }}</p>
        </div>

        <div id="buttons-container" style="width: 15%;">
          <button 
            type="button"
            class="btn btn-sm btn-danger"
            @click="openModal({ modal: 'modalReclassify', title: 'Reclassificar', options: { agreeClassification: false } })"
          >
            <b>Discordo</b>
          </button>
          <button
            type="button"
            class="btn btn-sm btn-warning text-white ml-1"
            @click="openModal({ modal: 'modalReclassify', title: 'Confirmar', options: { agreeClassification: true }  })"
          >
            <b>Concordo</b>
          </button>
          <button
            type="button"
            class="btn btn-sm btn-success mt-1"
            :disabled="registro.status !== 1"
            @click="openModal({
              modal: 'modalConfirm',
              title: 'Deseja realmente marcar como reclassificada no SIM?',
              action: () => setReclassifiedSIM(),
            })"
          >
            <b>Reclassificado no SIM</b>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade show" style="display: block;" v-if="modalReclassify.show">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ modalReclassify.title }}</h5>
      </div>
      
      <div class="modal-body">
        <div v-show="errorMessage != ''" class="alert alert-danger">{{ errorMessage }}</div>
        <div id="reclassification-container" class="d-flex">
          <label for="reclassification-select" class="mr-3">Reclassificação: </label>
          <model-select 
            :options="cidsToShow"
            v-model="reclassificationInput"
            :filterPredicate="myFilterPredicate"
          >
          </model-select>
        </div>

        <label for="disagree-justification-text">Justificativa: </label>
        <textarea name="disagree-justification-text" v-model="disagreeJustificationText" id="disagree-justification-text" class="w-100 border rounded form-control" style="resize: none;"></textarea>
      </div>

      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-sm btn-danger" @click="closeModal('modalReclassify')"><b>Cancelar</b></button>
        <button type="button" class="btn btn-sm btn-success" @click="openReclassifyConfirmModal()"><b>Confirmar</b></button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade show" style="z-index: 9999; display: block;" v-if="modalReclassifyConfirm.show">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ modalReclassifyConfirm.title }}</h5>
      </div>
      <div class="modal-body">
        <label style="float: left">Reclassificação: </label>&nbsp;{{ reclassificationSelected }}
        <br/><br/>
        <label style="float: left">Justificativa: </label>&nbsp;{{ disagreeJustificationText }}
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-sm btn-danger" @click="closeModal('modalReclassifyConfirm')"><b>Cancelar</b></button>
        <button type="button" class="btn btn-sm btn-success" @click="reclassify()"><b>Confirmar</b></button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade show" style="display: block;" v-if="modalConfirm.show">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header"></div>
      <div class="modal-body">
        <h5 class="modal-title">{{ modalConfirm.title }}</h5>
      </div>
      <div class="modal-footer justify-content-between">
        <button
          type="button"
          class="btn btn-sm btn-danger"
          @click="modalConfirm.actionCancel ? modalConfirm.actionCancel() : closeModal('modalConfirm')"
        >
          <b>Cancelar</b>
        </button>
        <button type="button" class="btn btn-sm btn-success" @click="modalConfirm.action()"><b>Confirmar</b></button>
      </div>
    </div>
  </div>
</div>
